export const getSectionSlug = (name: string) =>
  name
    .replace(/,/g, '') // Remove commas
    .replace(/\s+/g, '') // Remove all spaces
    .toLowerCase();
